<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Previous Remuneration YTD (TP3)

      <v-tooltip
        v-if="companyEmployee.previous_remuneration"
        bottom
        min-width="250"
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            class="pr-1"
            small
            color="info"
            v-on="{ ...tooltip }"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <div>Created by: <b>{{ ((companyEmployee||{}).previous_remuneration||{}).created_by }}</b> on <b>{{ $moment(((companyEmployee||{}).previous_remuneration||{}).created_at).format('DD-MM-YYYY') }}</b></div>
        <div>Updated by: <b>{{ ((companyEmployee||{}).previous_remuneration||{}).updated_by }}</b> on <b>{{ $moment(((companyEmployee||{}).previous_remuneration||{}).updated_at).format('DD-MM-YYYY') }}</b></div>
      </v-tooltip>

      <employee-profile-payroll-payroll-company-previous-remuneration-dialog-create
        v-if="!companyEmployee.end_date && !companyEmployee.previous_remuneration && $hasPermissionTo(['update employee payroll'])"
        :company-employee-uid="companyEmployee.company_employee_uid"
        @created="$emit('created')"
      />

      <employee-profile-payroll-payroll-company-previous-remuneration-dialog-edit
        v-if="companyEmployee.previous_remuneration && $hasPermissionTo(['update employee payroll'])"
        :previous-remuneration="companyEmployee.previous_remuneration"
        @updated="$emit('updated')"
      />
    </h4>
    
    <v-row class="mx-0">
      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Previous Company Resigned Date:</span>
      </v-col>
      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).recorded_date ? $moment(((companyEmployee||{}).previous_remuneration||{}).recorded_date).format('D MMM YYYY'):'N/A' }}</span> 
      </v-col>
    </v-row>
    <v-row class="mx-0">
      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Accumulated Remuneration:</span>
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).accumulated_remuneration?'RM ' + thousandSeparator(twoDigit(((companyEmployee||{}).previous_remuneration||{}).accumulated_remuneration)):'N/A' }}</span> 
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Accumulated PCB:</span>
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).accumulated_pcb? 'RM ' + thousandSeparator(twoDigit(((companyEmployee||{}).previous_remuneration||{}).accumulated_pcb)):'N/A' }}</span> 
      </v-col>
            
      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Accumulated EPF:</span>
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).accumulated_epf? 'RM ' + thousandSeparator(twoDigit(((companyEmployee||{}).previous_remuneration||{}).accumulated_epf)):'N/A' }}</span> 
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Amount of Zakat:</span>
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).accumulated_zakat? 'RM ' + thousandSeparator(twoDigit(((companyEmployee||{}).previous_remuneration||{}).accumulated_zakat)) :'N/A' }}</span> 
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Accumulated EIS:</span>
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).accumulated_eis? 'RM ' + thousandSeparator(twoDigit(((companyEmployee||{}).previous_remuneration||{}).accumulated_eis)) :'N/A' }}</span> 
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Levy Exemption for Umrah Travel:</span>
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).accumulated_levy_exemption? 'RM ' + thousandSeparator(twoDigit(((companyEmployee||{}).previous_remuneration||{}).accumulated_levy_exemption)) :'N/A' }}</span> 
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="font-weight-medium">Accumulated SOCSO:</span>
      </v-col>

      <v-col
        cols="3"
        class="py-0"
      >
        <span class="pl-3">{{ ((companyEmployee||{}).previous_remuneration||{}).accumulated_socso? 'RM ' + thousandSeparator(twoDigit(((companyEmployee||{}).previous_remuneration||{}).accumulated_socso)) :'N/A' }}</span> 
      </v-col>
    </v-row>

    <v-row class="mx-0 font-weight-bold">
      <v-col>
        Previous Company Tax Exemption
        <employee-profile-payroll-payroll-company-previous-remuneration-tax-exemptions-dialog-create
          v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
          :company-employee-uid="companyEmployee.company_employee_uid"
          :existing-tax-exemption="existingTaxExemptions"
          :recorded-date="((companyEmployee||{}).previous_remuneration||{}).recorded_date"
          @created="loadData"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="companyEmployeeTaxExemptions.length > 0"
      class="px-3"
      no-gutters
    >
      <v-col
        cols="4"
        class="font-weight-bold"
      >
        <span>Tax Exemption</span>
      </v-col>
      <v-col
        cols="4"
        class="font-weight-bold text-right"
      >
        <span>Amount (RM)</span>
      </v-col>

      <v-col cols="4" />

      <v-col cols="12">
        <v-row
          v-for="companyEmployeeTaxExemption in companyEmployeeTaxExemptions"
          :key="companyEmployeeTaxExemption.id"
          no-gutters
        >
          <v-col
            cols="4"
            :class="{
              'red--text': companyEmployeeTaxExemption.tax_exemption.amount < companyEmployeeTaxExemption.amount, 
            }"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  class="pr-1"
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ companyEmployeeTaxExemption.created_by }}</b> on <b>{{ $moment(companyEmployeeTaxExemption.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ companyEmployeeTaxExemption.updated_by }}</b> on <b>{{ $moment(companyEmployeeTaxExemption.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>

            {{ companyEmployeeTaxExemption.tax_exemption.name }}
          </v-col>
          <v-col
            cols="4"
            class="text-right"
            :class="{
              'red--text': companyEmployeeTaxExemption.tax_exemption.amount < companyEmployeeTaxExemption.amount, 
            }"
          >
            {{ thousandSeparator(twoDigit(companyEmployeeTaxExemption.amount)) }}
          </v-col>

          <v-col
            cols="4"
            class="text-center"
          >
            <employee-profile-payroll-payroll-company-previous-remuneration-tax-exemptions-dialog-edit
              v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
              :tax-exemption="companyEmployeeTaxExemption"
              @updated="loadData"
            />
            <employee-profile-payroll-payroll-company-previous-remuneration-tax-exemptions-dialog-delete
              v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
              :tax-exemption="companyEmployeeTaxExemption"
              @deleted="loadData"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      v-else
      class="px-3"
      no-gutters
    >
      <v-col>
        No Previous Tax Exemption
      </v-col>
    </v-row>

    <v-row class="mx-0 font-weight-bold">
      <v-col>
        Previous Company Tax Relief
        <employee-profile-payroll-payroll-company-previous-remuneration-tax-reliefs-dialog-create
          v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
          :company-employee-uid="companyEmployee.company_employee_uid"
          :existing-tax-relief="existingTaxReliefs"
          @created="loadData"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="companyEmployeePreviousTaxReliefs.length > 0"
      class="px-3"
      no-gutters
    >
      <v-col
        cols="4"
        class="font-weight-bold"
      >
        <span>Tax Relief</span>
      </v-col>
      <v-col
        cols="4"
        class="font-weight-bold text-right"
      >
        <span>Amount (RM)</span>
      </v-col>

      <v-col cols="4" />

      <v-col cols="12">
        <v-row
          v-for="companyEmployeePreviousTaxRelief in companyEmployeePreviousTaxReliefs"
          :key="companyEmployeePreviousTaxRelief.id"
          no-gutters
        >
          <v-col
            cols="4"
            :class="{
              'red--text': companyEmployeePreviousTaxRelief.tax_relief.amount < companyEmployeePreviousTaxRelief.amount, 
            }"
          >
            <v-tooltip
              bottom
              min-width="250"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  class="pr-1"
                  small
                  color="info"
                  v-on="{ ...tooltip }"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div>Created by: <b>{{ companyEmployeePreviousTaxRelief.created_by }}</b> on <b>{{ $moment(companyEmployeePreviousTaxRelief.created_at).format('DD-MM-YYYY') }}</b></div>
              <div>Updated by: <b>{{ companyEmployeePreviousTaxRelief.updated_by }}</b> on <b>{{ $moment(companyEmployeePreviousTaxRelief.updated_at).format('DD-MM-YYYY') }}</b></div>
            </v-tooltip>
            {{ companyEmployeePreviousTaxRelief.tax_relief.name }}
          </v-col>
          <v-col
            cols="4"
            class="text-right"
            :class="{
              'red--text': companyEmployeePreviousTaxRelief.tax_relief.amount < companyEmployeePreviousTaxRelief.amount, 
            }"
          >
            {{ thousandSeparator(twoDigit(companyEmployeePreviousTaxRelief.amount)) }}
          </v-col>

          <v-col
            cols="4"
            class="text-center"
          >
            <employee-profile-payroll-payroll-company-previous-remuneration-tax-reliefs-dialog-edit
              v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
              :company-employee-previous-tax-relief="companyEmployeePreviousTaxRelief"
              @updated="loadData"
            />
            <employee-profile-payroll-payroll-company-previous-remuneration-tax-reliefs-dialog-delete
              v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
              :company-employee-previous-tax-relief="companyEmployeePreviousTaxRelief"
              @deleted="loadData"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      v-else
      class="px-3"
      no-gutters
    >
      <v-col>
        No Previous Tax Relief
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/DialogEdit'),
    
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationTaxExemptionsDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/tax-exemptions/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationTaxExemptionsDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/tax-exemptions/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationTaxExemptionsDialogDelete: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/tax-exemptions/DialogDelete'),

      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationTaxReliefsDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/tax-reliefs/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationTaxReliefsDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/tax-reliefs/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyPreviousRemunerationTaxReliefsDialogDelete: () => import('@/components/hris/employee/profile/payroll/payroll-company/previous-remuneration/tax-reliefs/DialogDelete'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        showEdit: false,
        companyEmployeeTaxExemptions: [],
        existingTaxExemptions: [],
        companyEmployeePreviousTaxReliefs: [],
        existingTaxReliefs: [],
      }
    },

    watch: {
      companyEmployee: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadData()
          }
        },
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      twoDigit ($amount) {
        return (Math.round(($amount / 100) * 100) / 100).toFixed(2)
      },
      loadData () {
        Promise.all([
          this.$api.checkEmployeeIncludedInPayrollPeriods().list(this.companyEmployee.company_employee_uid),
          this.$api.companyEmployeeTaxExemptions().list(this.companyEmployee.company_employee_uid),
          this.$api.companyEmployeePreviousTaxReliefs().list(this.companyEmployee.company_employee_uid),
        ])
          .then(([payrollPeriod, companyEmployeeTaxExemption, companyEmployeePreviousTaxRelief]) => {
            if (!payrollPeriod.data) {
              this.showEdit = true 
            }

            this.companyEmployeeTaxExemptions = companyEmployeeTaxExemption.data
            this.existingTaxExemptions = this.companyEmployeeTaxExemptions.map(item => item.tax_exemption_id)

            this.companyEmployeePreviousTaxReliefs = companyEmployeePreviousTaxRelief.data
            this.existingTaxReliefs = this.companyEmployeePreviousTaxReliefs.map(item => item.tax_relief_id)
          })
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>
